import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, Table, Container } from "reactstrap";
import { H5 } from "../../../AbstractElements";
import { accountTypeService } from "Services";
import TableLoader from "CommonElements/Table/TableLoader";
import TableNodata from "CommonElements/Table/TableNodata";
import { Row } from "react-bootstrap";
import { FSwitch } from "CommonElements/Form";
import { Breadcrumbs } from '../../../AbstractElements';
import AddAccountType from "./AddAccountType";
import EditAccountType from "./EditAccountType";
import DeleteAccountType from "./DeleteAccountType";
import { toast } from "react-toastify";
import TablePagination from "CommonElements/Table/TablePagination";
import { useSelector } from "react-redux";
import { getMenuPerm } from 'utils';

// import { Link } from "react-router-dom";

const AccountTypes = () => {

  const [rec, setRec] = useState({});
  useEffect(() => {
    loadData(1);
  }, []);
  const loadData = (page = 1) => {
    setRec({
      loading: true,
      data: [],
    });
    accountTypeService
      .getAccountTypes({
        page,
      })
      .then((res) => {
        setRec({
          ...res,
          loading: false,
        });
      })
      .catch((err) => {
        console.log("err ", err);
      });
  }
  const permissions = useSelector(
    (state) => (state.login && state.login.profile && state.login.profile.Role && state.login.profile.Role.permissions) || {}
  );

  const changeStatus = (item, index, fieldName) => {
    accountTypeService
      .updateAccountType(
        item.id,
        {
          [fieldName]: !item[fieldName],
        },
      )
      .then((res) => {
        rec.data[index].isActive = !item.isActive;
        toast.success("Account Type updated, successfully");
      })
      .catch((err) => {
        toast.error("Failed to update Account Type");
      });
  };
  return (
    <Fragment>
      <Breadcrumbs title="Account Types" mainTitle='' />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="8">
                    {" "}
                    <H5>{'Account Types'}</H5>
                  </Col>
                  <Col md="4" className="" style={{textAlign: 'right'}}>
                  {getMenuPerm(permissions, 'accountTypes:create') === 1 &&
                    <AddAccountType loadData={loadData} />
                  }
                  </Col>
                </Row>
              </CardHeader>
              <div className="table-responsive">
                <Table hover>
                  <thead>
                    <tr>
                      <th scope="col">{"#"}</th>
                      <th scope="col">{"Title"}</th>
                      <th scope="col">{"Group Path"}</th>
                      <th scope="col">{"Type"}</th>
                      <th scope="col">{"Active"}</th>
                      <th scope="col">{"Show in CP"}</th>
                      <th scope="col">{"Show in CRM"}</th>
                      <th scope="col">{"Show in IB"}</th>
                      <th scope="col">{"Actions"}</th>

                    </tr>
                  </thead>
                  {rec.loading && <TableLoader />}
                  {!rec.loading && rec.data && rec.data.length === 0 && (
                    <TableNodata title="Account Types" />
                  )}
                  <tbody>
                    {rec.data &&
                      rec.data.map((item, id) => (
                        <tr key={id}>
                          <th scope="row">{item.id}</th>
                          <td>{item.title}</td>
                          <td>{item.groupPath}</td>
                          <td>{item.type}</td>
                          <td>
                          {getMenuPerm(permissions, 'accountTypes:update') === 1 &&
                            <FSwitch
                              onChange={() => {
                                changeStatus(item, id, 'isActive');
                              }}
                              value={item.isActive}
                            />}
                          </td>

                          <td>
                            {item.type === 'LIVE' && getMenuPerm(permissions, 'accountTypes:update') === 1 &&
                              <FSwitch
                              onChange={() => {
                                changeStatus(item, id, 'showInCp');
                              }}
                              value={item.showInCp}
                              />
                            }
                          </td>
                          <td>
                            {item.type === 'LIVE' && getMenuPerm(permissions, 'accountTypes:update') === 1 &&
                              <FSwitch
                              onChange={() => {
                                changeStatus(item, id, 'showInCrm');
                              }}
                              value={item.showInCrm}
                              />
                            }
                          </td>
                          <td>
                            {item.type === 'LIVE' && getMenuPerm(permissions, 'accountTypes:update') === 1 &&
                              <FSwitch
                              onChange={() => {
                                changeStatus(item, id, 'showInIbAgreement');
                              }}
                              value={item.showInIbAgreement}
                              />
                            }
                          </td>

                         
                          <td>
                          {getMenuPerm(permissions, 'accountTypes:update') === 1 &&
                            <EditAccountType data={item} loadData={loadData} />
                          }
                          {getMenuPerm(permissions, 'accountTypes:delete') === 1 &&
                            <DeleteAccountType data={item} loadData={loadData} />
                          }
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
            <TablePagination data={rec} loadData={loadData} />
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AccountTypes;
